import { Point2D } from "~/types/api";

export const pointEquals: (_: Point2D) => (_: Point2D) => boolean =
  ({ x: x1, y: y1 }) =>
  ({ x: x2, y: y2 }) =>
    x1 === x2 && y1 === y2;
